import { useLayoutEffect } from 'react';
import { useDependencies } from '@servicetitan/react-ioc';
import { FinancingApi } from '@servicetitan/financing-api-client';
import { PrequalsApi } from '@servicetitan/financing-api-client/src/prequals-api';
import { FintechDataApi } from '@servicetitan/financing-api-client/src/fintech-data-api';
import { SetupDataStore } from '../stores/setupDataStore';

export const useSyncProviderToFinancingApi = () => {
    const { setupData } = SetupDataStore.useStore();
    const [financingApi] = useDependencies(FinancingApi);
    const [prequalsApi] = useDependencies(PrequalsApi);
    const [fintechDataApi] = useDependencies(FintechDataApi);

    // Use useLayoutEffect to ensure this runs synchronously before any child effects
    useLayoutEffect(() => {
        if (setupData?.provider) {
            financingApi.setFinancingProvider(setupData.provider);
            prequalsApi.setFinancingProvider(setupData.provider);
            fintechDataApi?.setFinancingProvider(setupData.provider);
        }
    }, [setupData?.provider, financingApi, prequalsApi, fintechDataApi]);
};
